import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL = process.env.VUE_APP_BASE_API_URL + '/api/v1/super-admin/news'

class NewsApi {
  getList(page, size) {
    return axios.get(API_URL + '?actualPage=' + page + '&perPage=' + size, {
      headers: authHeader()
    })
  }

  getDetail(uuid) {
    return axios.get(API_URL + '/' + uuid, { headers: authHeader() })
  }

  createNews(data) {
    return axios.post(API_URL, data, { headers: authHeader() })
  }

  updateNews(uuid, data) {
    return axios.put(API_URL + '/' + uuid, data, { headers: authHeader() })
  }
}

export default new NewsApi()
